import styled from '@emotion/styled'
import { font, colors } from '@mobi/component-library/Foundations'

export const AccountBalanceHeaderStyled = styled.div({
  display: 'flex',
  flexFlow: 'row nowrap',
  justifyContent: 'space-between',
  padding: '1.6rem',
  alignItems: 'center',
  fontSize: font.size.md.fontSize,
  letterSpacing: font.size.md.letterSpacing,
  lineHeight: font.size.md.lineHeight,
  fontFamily: font.family.primary,
  fontWeight: font.weight.regular,
})

export const AccountBalanceTitleStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  '& > span': {
    padding: '0.8rem',
    background: colors.surface['400'],
    borderRadius: '50%',
  },
})

export const AccountBalanceAmountStyled = styled.div({
  color: colors.studio['500'],
})
